// Auto-refactored from translations.js on 2026-08-19
// Locale: ro

const ro = {
  wieMoeglich: { question: 'Cum este posibil?', answer: 'Am regândit lanțul valoric.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Calea STIG ROCK',
    fazit: 'Lanțul de aprovizionare scurtat elimină cele mai mari poziții de cost.',
    fazitBigPre: 'Acest lucru permite o reducere de până la',
    fazitBigValue: '80%',
    steps: [ 'Mină', 'Atelier de șlefuire', 'Certificare', 'Client final' ]
  },
  nav: { language: 'Limbă', contact: 'Contact' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'O oportunitate unică',
    subtitle: 'Construirea averii orientată spre viitor.',
    description: 'STIG ROCK este o platformă internațională care oferă oamenilor acces la diamante naturale, construirea durabilă a averii și o comunitate unică.',
    scroll: 'Derulează pentru a descoperi'
  },
  disclaimer: {
    overline: 'Notă legală',
    title: 'Disclaimer',
    paragraphs: [
      'Această prezentare are doar scop informativ și nu constituie consultanță financiară, de investiții sau fiscală.',
      'STIG ROCK nu este un produs financiar, ci se referă la diamante naturale ca active corporale.',
      'Nu se oferă nicio garanție pentru evoluția valorii, profituri sau randamente. Evoluțiile trecute nu reprezintă o indicație pentru rezultatele viitoare.',
      'Toate calculele prezentate în legătură cu comisioanele sunt doar exemplificative și nu reprezintă, de asemenea, nicio garanție.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'CONSTRUIT', 'PE STRUCTURĂ' ],
    body: 'STIG Group este un concern internațional, construit pe claritate, responsabilitate și valoare pe termen lung. Fiecare marcă, fiecare proiect și fiecare parteneriat urmează un singur standard — fără scurtături, fără excepții.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'CONSTRUIT', 'PE STRUCTURĂ' ],
        body: 'STIG Group este un concern internațional, construit pe claritate, responsabilitate și valoare pe termen lung. Fiecare marcă, fiecare proiect și fiecare parteneriat urmează un singur standard — fără scurtături, fără excepții.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'LUMEA', 'DIAMANTELOR EXCLUSIVE' ],
        body: 'STIG ROCK este un concept modern al STIG Group, care combină diamante de înaltă calitate certificate GIA cu structuri transparente și o experiență exclusivă pentru clienți. Planuri de soluții clare, procesare profesională și orientare internațională.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'COMERȚ INTERNAȚIONAL', 'CU DIAMANTE' ],
        body: 'STIG International face parte din STIG Group și este specializat în comerțul internațional cu diamante certificate GIA. Focus pe calitate, încredere și structuri comerciale moderne cu parteneriate globale.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'RESPONSABILITATE', 'DE LA MINĂ' ],
        body: 'Ethical Mines reprezintă extracția responsabilă, proveniența trasabilă și diamantele fără conflicte. De la mină la piață — documentație completă pentru transparență, integritate și responsabilitate pe termen lung pe tot lanțul de aprovizionare.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamante',
    stigDrawback: 'Depozit real de valoare',
    overline: 'Oportunități',
    title: 'Oportunități pentru construirea averii',
    subtitle: 'Căi tradiționale în comparație.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex sau Krypto',
        drawback: 'foarte speculativ, imprevizibil, complex'
      },
      {
        tag: 'Acțiuni',
        name: 'Tranzacționare la bursă',
        drawback: 'risc de fluctuație, cunoștințe necesare, timp investit'
      },
      {
        tag: 'Krypto',
        name: 'Tranzacționare',
        drawback: 'volatilitate, risc de reglementare, breșe de securitate'
      }
    ]
  },
  chance: {
    overline: 'Diamante',
    title: 'Oportunitatea subestimată',
    body: 'Diamantele sunt de ani de zile printre cele mai stabile și promițătoare forme de investiție, însă până acum doar puțini au profitat de acest potențial.',
    callout: 'Cu STIG ROCK, deschidem pentru prima dată tuturor accesul la aceste posibilități extraordinare.'
  },
  wertentwicklung: {
    overline: 'Evoluția valorii 1995 — 2025',
    title: 'O istorie despre valoare.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamante',
    diamondValue: '+185%',
    note: 'Evoluție din 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Motive principale',
    title: 'Șase motive pentru diamante',
    lead: 'Diamantele sunt active corporale reale care există independent de monede și sisteme financiare — și își păstrează valoarea de secole.',
    items: [
      {
        n: '01',
        title: 'Stabilitate a valorii rezistentă la criză',
        body: 'Garanția activelor reale. Independent de monede și sisteme financiare.'
      },
      {
        n: '02',
        title: 'Mobilitatea supremă',
        body: 'Mici, ușor de ascuns și de transportat.'
      },
      {
        n: '03',
        title: 'Diversificare & Raritate',
        body: 'Blocaje în aprovizionare și limitare naturală.'
      },
      { n: '04', title: 'Creștere pe termen lung', body: '+185% din 1995.' },
      {
        n: '05',
        title: 'Transparență & Exclusivitate',
        body: 'Cele 4 C-uri ca garanție: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Rezerva caselor regale',
        body: 'Chiar și casele regale folosesc diamantele ca rezervă de avere.'
      }
    ]
  },
  markt: {
    overline: 'Volumul pieței',
    title: '99 — 108 Mrd. USD',
    sub: 'Volumul tranzacțiilor în anul 2025',
    forecast: 'Prognoză până în ~2032 / 2034: cca. 140 – 168 Mrd. USD cu o creștere moderată (~4 – 5 % p.a.).',
    source: 'Sursă: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Inovație',
    title: 'O inovație. Pentru prima dată în lume.',
    body: 'STIG ROCK este prima platformă la nivel mondial care permite persoanelor să obțină un venit pasiv în piața diamantelor, în plus față de aprecierea valorii.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Nr. înregistrare DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Despre companie',
    titleLines: [ 'STRUCTURĂ', 'INTERNAȚIONALĂ', 'VIZIUNE CLARĂ' ],
    body: 'STIG ROCK a fost fondat pentru a face piața diamantelor mai transparentă, modernă și orientată către client — cu accent pe încredere, securitate și structură pe termen lung.'
  },
  sicherheit: {
    overline: 'Calitate & Siguranță',
    title: 'Gemological Institute of America',
    body: 'Expertiză certificată pentru diamantele dumneavoastră. GIA evaluează fiecare piatră cu cea mai înaltă precizie și experiență de mulți ani — rapoarte de evaluare fiabile pentru compania noastră și clienții noștri.',
    transparency: 'Fiecare diamant îndeplinește cele mai înalte standarde de calitate și este verificat și certificat de organizații renumite. Fiecare piatră este unică și primește un certificat individual.',
    kimberley: 'Kimberley Process — lucrăm exclusiv cu diamante fără conflicte.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'O inovație de produs unică',
    sub: 'Șase Planuri de Soluție eșalonate — de la $1K la $100K+, fiecare cu un discount crescător pe lună și pe întreaga durată.',
    recommended: 'Popular',
    oneYear: '1 an',
    rowLabels: {
      delivery: 'Timp de livrare',
      price: 'Preț produs',
      carat: 'Carat',
      monthly: 'Discount (Lună)',
      totalDiscount: 'Discount (Total)',
      duration: 'Durată'
    },
    headers: {
      plan: 'Plan',
      from: 'De la',
      carat: 'Carat',
      monthly: 'Discount / Lună',
      total: 'Discount Total',
      duration: 'Durată'
    },
    duration: '1 an',
    footnote: 'Toate prețurile sunt fără garanție și depind de calitate, cerere și evoluția actuală a pieței. Planurile Solution sunt posibile și pentru 2 ani.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + Pachet VIP',
    title: 'Mai mult discount cu Pachetul VIP',
    sub: 'Discount Total per plan – combinat cu un Pachet VIP primești +1% până la +3% suplimentar, ceea ce crește vizibil discountul total.',
    rowLabels: {
      delivery: 'Timp de livrare',
      price: 'Preț produs',
      carat: 'Carat',
      monthly: 'Discount (Lună)',
      totalDiscount: 'Discount (Total)',
      vip1: 'Pachet VIP 1 (+1%)',
      vip2: 'Pachet VIP 2 (+2%)',
      vip3: 'Pachet VIP 3 (+3%)'
    },
    footnote: 'Toate prețurile sunt fără garanție și depind de calitate, cerere și evoluția actuală a pieței.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Posibilitățile tale',
    sub: 'După expirarea planului tău Solution, poți fie să ne revinzi diamantele, fie să soliciți livrarea lor la tine acasă.',
    options: [
      {
        key: 'deliver',
        title: 'Livrare',
        body: 'Diamante (Carat) la prețul planului tău DS*'
      },
      {
        key: 'sellToUs',
        title: 'Vinde-ne nouă',
        body: 'Poți să ne revinzi diamantele la prețul de achiziție plătit de tine.'
      },
      {
        key: 'sellThirdParty',
        title: 'Vinde către terți',
        body: 'Poți să îți revinzi diamantele către terți.'
      }
    ],
    footnote: '*Planul DS reprezintă Planul Solution.'
  },
  tradWeg: {
    overline: 'Comerț tradițional',
    title: 'Calea tradițională',
    sub: 'Înainte ca un diamant să ajungă la clientul final, prin comerțul intermediar, en-gros și en-detail apar marje comerciale considerabile față de prețul diamantului brut din mină.',
    steps: [
      { title: 'Mină', subtitle: 'Diamante brute' },
      { title: 'Intermediar', subtitle: 'Achiziție diamante brute' },
      { title: 'Atelier de tăiere', subtitle: 'Tăiere în diamante pentru bijuterii' },
      { title: 'Certificare', subtitle: 'prin institute recunoscute precum GIA' },
      { title: 'Bursa de diamante', subtitle: 'Vânzare către en-gros' },
      { title: 'En-gros', subtitle: 'Vânzare către retail' },
      { title: 'Retail', subtitle: 'de ex. bijutieri' },
      { title: 'Clienți finali', subtitle: 'Cumpărare de diamante' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'Calea STIG ROCK',
    sub: 'Noi întrerupem acest circuit prin cumpărarea diamantelor brute direct din mină, tăierea și certificarea lor prin partenerii noștri. Astfel, putem oferi aceste marje comerciale clienților noștri sub formă de credite de discount.',
    duration: '12 luni – durata Planului DS',
    centerBig: '04',
    centerCaption: 'Până la 4 cicluri comerciale în timpul duratei Planului DS',
    cycle: [
      { n: '1.', title: 'Cumpărarea mai multor diamante brute', body: 'pentru un Plan DS' },
      { n: '2.', title: 'Tăiere și certificare', body: 'prin partenerii noștri' },
      { n: '3.', title: 'Vânzare către clienți finali', body: 'și comercianți en-gros' },
      { n: '4.', title: 'Repetăm acest proces', body: 'de până la 4 ori pe an' }
    ],
    steps: [
      { title: 'Mină', subtitle: 'Diamante brute' },
      { title: 'Atelier de tăiere', subtitle: 'prin partenerii noștri' },
      { title: 'Certificare', subtitle: 'prin institute recunoscute' },
      { title: 'Clienți finali', subtitle: 'Cumpărare & credite de discount' }
    ],
    footnote: '*Planul DS reprezintă Planul Solution.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Pachete VIP',
    sub: 'Valabil timp de 12 luni pentru toate Planurile Solution subscrise de tine. În funcție de Pachetul VIP: +1% până la +3% discount suplimentar',
    cardKicker: 'suplimentar – pentru toate',
    cardKicker2: 'Planurile Solution',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Din discounturi devin economii',
      body: 'Economie lunară în loc de povară lunară. Din discounturi apar economii — iar acestea plătesc exact lucrurile pentru care altfel plătești lunar din propriul buzunar.',
      line1Label: 'Plan DS de la',
      line1Value: '$5.000',
      line2Label: 'disc. lunar',
      line2Value: '3%',
      line3Label: 'Pachet VIP 3',
      line3Value: '+3%',
      resultLabel: 'economii lunare',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Cum este posibil?',
    title: 'Am regândit lanțul valoric.',
    traditionalTitle: 'Calea tradițională',
    traditionalSteps: [
      'Mină — Diamante brute',
      'Intermediar — Achiziție',
      'Atelier de tăiere — Tăiere',
      'Certificare (GIA)',
      'Bursa de diamante — En-gros',
      'En-gros → Retail',
      'Bijutieri → Client final'
    ],
    traditionalNote: 'Înainte ca un diamant să ajungă la clientul final, prin comerțul intermediar, en-gros și en-detail apar marje comerciale considerabile.',
    stigTitle: 'Calea STIG ROCK',
    stigSteps: [
      'Achiziție directă — Diamante brute din mină',
      'Tăiere & Certificare prin partenerii noștri',
      'Vânzare către clienți finali & clienți B2B',
      'Până la 4 cicluri comerciale pe an'
    ],
    stigNote: 'Noi întrerupem circuitul și oferim marjele comerciale ca credite de discount clienților noștri — până la 4 cicluri comerciale în timpul duratei Planului DS.'
  },
  optionen: {
    overline: 'Posibilitățile tale',
    title: 'După expirarea planului tău Solution',
    items: [
      { title: 'Livrare', body: 'Diamante (Carat) la prețul planului tău DS.' },
      { title: 'Vinde-ne nouă', body: 'Re-vânzare la prețul de achiziție plătit de tine.' },
      { title: 'Vinde către terți', body: 'Vânzarea diamantelor pe piața liberă.' }
    ]
  },
  einfacherWeg: {
    overline: 'Planuri Solution — o inovație de produs unică',
    title: 'Calea simplă',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Înregistrare',
        body: 'Contactează persoana care ți-a recomandat și creează un cont gratuit!'
      },
      { n: '02', icon: 'cart', title: 'Achiziția unui produs', body: 'Deja de la $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Primești discounturi',
        body: 'Primești credite de discount lunare.'
      }
    ]
  },
  business: {
    overline: 'Tipuri de bonusuri',
    title: 'Cea mai simplă și corectă cale.',
    sub: 'Cinci tipuri de bonusuri — pentru succesul afacerii tale.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Până la nivelul 3, de la nivelul de carieră Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'De la Sapphire — adâncime infinită.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'La Infinity Bonus – până la nivelul 5 · FĂRĂ calificare.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pool-uri din cifra de afaceri mondială.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Bonus unic în diamante (Carat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Acest bonus îți este plătit pentru fiecare Plan Solution nou subscris până în nivelul 3. Cu calificări foarte reduse, deblochezi nivelurile individuale.',
    total: 'Până la 18% Unilevel Bonus',
    levels: [
      {
        level: 'Nivel 1',
        value: '10%',
        qual: 'de la început',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Nivel 2',
        value: '5%',
        qual: 'de la nivelul de carieră Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Nivel 3',
        value: '3%',
        qual: 'de la nivelul de carieră Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'De la nivelul de carieră Sapphire ești calificat pentru planul nostru de Infinity Bonus. Primești 3% bonus. Cu fiecare nou nivel de carieră, se adaugă procente suplimentare. Dacă un partener din echipa ta este de asemenea calificat, primești diferența de la rang la rang.',
    exampleTitle: 'Exemplu',
    exampleRows: [
      { label: 'Ești Blue Diamond', value: '12%' },
      { label: 'Partenerul tău este Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Infinity Bonus-ul tău', value: '9%' },
    totalNote: 'Total până la 24% Infinity Bonus pentru toate Planurile Solution subscrise în echipa ta — adâncime infinită.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Cu acest bonus profiți de succesul echipei tale. Primești un Matching Bonus de 5% din Infinity Bonus-ul partenerilor tăi — și asta până la al 5-lea nivel al echipei tale.',
    note: 'Pentru toate plățile Infinity Bonus din echipa ta – până în nivelul 5. De la început – FĂRĂ calificare.',
    levels: [
      { level: 'Nivel 1', value: '5%' },
      { level: 'Nivel 2', value: '5%' },
      { level: 'Nivel 3', value: '5%' },
      { level: 'Nivel 4', value: '5%' },
      { level: 'Nivel 5', value: '5%' }
    ],
    totalPrefix: 'Total până la',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% din cifra de afaceri mondială curge în părți egale în 3 pool-uri diferite. Prin atingerea anumitor niveluri de carieră, te califici pentru fiecare pool în parte.',
    forever: 'Odată atins – participi PENTRU TOTDEAUNA!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'de la Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'de la Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'de la Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Total',
    totalValue: '3%',
    totalSuffix: 'din cifra de afaceri mondială'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'De la nivelul de carieră Diamond primești un Rang Bonus. Acesta este plătit în diamante (Carat). Este vorba despre un bonus unic.',
    highlight: 'Diamante (Carat) în valoare totală de',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Niveluri de carieră',
    title: 'Niveluri de carieră',
    sub: 'Pentru atingerea respectivelor niveluri de carieră contează volumul total istoric (HG). Acesta trebuie, de la nivelul Sapphire, să fie distribuit pe mai multe echipe. Pentru a atinge Ruby sau mai sus, ai nevoie de cel puțin doi parteneri direcți cu un Plan Solution.',
    forever: 'Odată atins – confirmat PENTRU TOTDEAUNA!',
    footnote: 'HV = Istoric de vânzări total.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 parteneri dir.', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Începe acum cu noi',
    title: 'Momentul potrivit este chiar acum.',
    body: 'Acest model de afaceri stabilește noi standarde și reunește toți factorii de succes pentru o afacere durabilă și prosperă pe termen lung. Înregistrează-te astăzi, alege-ți Planul Solution și profită de această oportunitate unică de afaceri.',
    hint: 'Vorbește cu persoana care te-a invitat la această prezentare — are un link de înregistrare pentru tine.',
    formName: 'Nume',
    formEmail: 'E-mail',
    formPhone: 'Telefon',
    formSubmit: 'Contactează-ne',
    success: 'Vă mulțumim — vă vom contacta discret și personal.',
    callCta: 'Sună',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Notă legală & Disclaimer',
    disclaimer: 'Această prezentare are doar scop informativ și nu constituie consultanță financiară, de investiții sau fiscală. STIG ROCK nu este un produs financiar, ci se referă la diamante naturale ca active corporale. Nu se oferă nicio garanție pentru evoluția valorii, profituri sau randamente. Evoluțiile trecute nu reprezintă o indicație pentru rezultatele viitoare. Toate calculele prezentate în legătură cu comisioanele sunt doar exemplificative și nu reprezintă, de asemenea, nicio garanție. Sub rezerva modificărilor de conținut — traducere liberă (nu este o traducere oficială).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Toate drepturile rezervate.',
    version: 'Versiune: DS-12-2025 V3'
  },
  misc: { next: 'Secțiunea următoare' }
};

export default ro;
